// Test IDs for the GMOAA public website.

export const GMOAA = {
  langToggle: 'lang-toggle',
  helpLink: 'utility-help-link',
  memberLoginBtn: 'member-login-btn',
  memberLoginModal: 'member-login-modal',
  memberLoginClose: 'member-login-close',
  raiseIssueBtn: 'raise-issue-btn',
  navHome: 'nav-home',
  navAbout: 'nav-about',
  navBearers: 'nav-bearers',
  navDistricts: 'nav-districts',
  navGr: 'nav-gr',
  navGapl: 'nav-gapl',
  navAdvertise: 'nav-advertise',
  navContact: 'nav-contact',
  mobileMenuBtn: 'mobile-menu-btn',
  importantBar: 'important-bar',
  importantDismiss: 'important-dismiss',
  gaplCountdown: 'gapl-countdown',
  grTabGr: 'gr-tab-gr',
  grTabNotices: 'gr-tab-notices',
  grSearch: 'gr-search',
  grFilter: 'gr-filter',
  districtCard: 'district-card',
  bearerCard: 'bearer-card',
  contactForm: 'contact-form',
  contactName: 'contact-name',
  contactEmail: 'contact-email',
  contactMobile: 'contact-mobile',
  contactCategory: 'contact-category',
  contactSubject: 'contact-subject',
  contactMessage: 'contact-message',
  contactSubmit: 'contact-submit',
  adSlot: 'ad-slot',
};
